// User status the app uses to pick a homepage feed. Not the content ACCESS_TYPE.
export const ACCESS_SEGMENTS = ['free', 'trial', 'subscriber'] as const;

export type AccessSegment = (typeof ACCESS_SEGMENTS)[number];

export interface UserLevel {
  level: number;
  title: string;
}

// The app's requirement-based levels (userLevels/{uid}.level). Mirrors LEVELS in
// alux-backend functions/config/levels.js; update both together.
export const USER_LEVELS: UserLevel[] = Array.from({ length: 10 }, (_, index) => ({
  level: index + 1,
  title: `Level ${index + 1}`,
}));

export interface HomeShortsFeed {
  /** client-generated, stable */
  id: string;
  /** e.g. "New free users" */
  name: string;
  /** USER_LEVELS level values; [] = any level */
  levels: number[];
  /** [] = any access */
  access: AccessSegment[];
  /** ranked; index 0 = first short shown */
  shortIds: string[];
  isActive: boolean;
}

// Admin-only editorial note for ranking. The backend and the app ignore it.
export interface ShortNote {
  /** 0-10, null = not scored */
  worth: number | null;
  why: string;
  goldStar: boolean;
}

export interface HomeShortsFeeds {
  /** array order = priority; the first active match wins */
  feeds: HomeShortsFeed[];
  /** fallback for everyone else */
  default: { shortIds: string[] };
  /** admin-only notes keyed by shortId, shared by all feeds; missing = no note */
  notes?: Record<string, ShortNote>;
  /** written as serverTimestamp() on save */
  updatedAt?: unknown;
}
